import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-photoitem',
  templateUrl: './photoitem.component.html',
  styleUrls: ['./photoitem.component.css']
})
export class PhotoitemComponent implements OnInit {
  @Input() photo: any;
  @Input() photoPlace: number ;
  @Input() question: number;
  @Input() group: number;
  @Output() removePhoto = new EventEmitter<{photo: object}>();

  constructor() { }

  ngOnInit(): void {
  }

  delPhoto() {
    let photo:any = {};
    photo.place = this.photoPlace;
    photo.q = this.question;
    photo.g = this.group;
    // console.log(photo);
    this.removePhoto.emit(photo);
  }
}
